import type { ParsedTemplateVariable } from '@/components/organisms/template-variable-editor/template-variable.interface'

/**
 * Removes duplicate variables by name, keeping only the first occurrence.
 * Template content may reference the same variable multiple times,
 * so the form should render each unique variable only once.
 */
export const deduplicateVariableList = (
  variableList: ParsedTemplateVariable[]
): ParsedTemplateVariable[] => {
  const seenNameSet = new Set<string>()
  const resultList: ParsedTemplateVariable[] = []

  for (const variable of variableList) {
    if (seenNameSet.has(variable.name)) continue
    seenNameSet.add(variable.name)
    resultList.push(variable)
  }

  return resultList
}
